<template>
    <div class="m-view__pay">
        <div class="title"></div>
        <div class="slogen">
            <p>活动期间，所有成员消费梦三币将等额返还结义值</p>
            <p>（每人上限3000），每个人均可获得当前的总返还结义值</p>
            <p>（含本人和小队成员消费返还的结义值）</p>
        </div>

        <div class="pay-pannel">
            <div class="total-pay">
                <div class="t-total"></div>
                <div class="sum">{{ sum }}<em class="icon-token sprite sprite-icon-token"></em></div>                
            </div>

            <div class="team-list">
                <div class="list-item" v-for="(item,index) in back_list" :key="index">
                    <p class="nick needLang ali">{{ item.nickName }}</p>
                    <p class="amt">返还 <b>{{ item.cost }}</b>/3000<em class="icon-token sprite sprite-icon-token"></em></p>
                </div>
                <div class="list-item" v-for="n in 3 - back_list.length" :key="'temp-' + n">
                    <p class="nick">— —</p>
                    <p class="amt">返还 <b>0</b>/3000<em class="icon-token sprite sprite-icon-token"></em></p>                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { apiBackInfo } from '@/api/index';

export default {
    data (){
        return {
            back_list : [],
            sum : 0,
        }
    },
    mounted(){
        this.render();
    },
    watch : {
        back_list : {
            handler(newVal, oldVal) {
               this.sum_amt();                  
            },
            deep: true
        },                 
    },       
    methods : {
        render (){
            apiBackInfo().then(
                res => {
                    this.back_list = res.data;
                },
                rej => {},
            )
        },
        sum_amt(){
            var s = 0;
            this.back_list.forEach(function(val) {
                s += val.cost;
            }, 0);

            this.sum = s;
        },        
    },
}
</script>

<style lang="scss" scoped>
.title{
    width: 557px;
    height: 56px;
    margin: 35px auto 28px;
    background-image: url(~@/assets/images/slogen-pay.png);   
}

.slogen{
    color: #fbdebb;
    text-align: center;
}

.pay-pannel{
    position: relative;
    width: 721px;
    height: 358px;
    margin: 30px auto 0;
    background-image: url(~@/assets/images/pay-pannel.png);
    
    .total-pay{
        position: absolute;
        left: 40px;
        bottom: 60px;
        width: 207px;
        height: 97px;
        padding-top: 36px;
        //background-image: url(~@/assets/images/back-all.png);

        color: #fff0b5;
        font-size: 44px;
        font-weight: 700;
        text-align: center;

        .t-total{
            width: 70px;
            height: 22px;
            margin: 0 auto 10px;
            background-image: url(~@/assets/images/label-total-pay.png);
        }
    }

    .team-list{
        position: absolute;
        bottom: 53px;
        right: 64px;
    }

    .list-item{
        width: 355px;
        height: 80px;
        margin-bottom:5px;
        padding-top: 7px;
        padding-left: 25px;
        background-image: url(~@/assets/images/item-pay.png);

        .nick{

            margin-bottom: 4px;
            color: #a6311c;
        }

        .amt{
            color: #63372a;

            b{
                font-weight: 400;
                color: #ca3113;
            }
        }
    }
}
</style>